import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function MyDonations() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);

  const purposeMap = {
    general: t('myDonations.purposeGeneral'),
    cow_adoption: t('myDonations.purposeCowAdoption'),
    fodder: t('myDonations.purposeFodder'),
    medical: t('myDonations.purposeMedical'),
    infrastructure: t('myDonations.purposeInfrastructure'),
    festival: t('myDonations.purposeFestival'),
  };
  const statusMap = {
    success: t('myDonations.statusSuccess'),
    pending: t('myDonations.statusPending'),
    failed: t('myDonations.statusFailed'),
  };

  useEffect(() => {
    API.get('/donations/my').then(r => { setDonations(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const total = donations.filter(d => d.paymentStatus === 'success').reduce((s, d) => s + d.amount, 0);

  return (
    <div>
      <div className="page-header">
        <h1>{t('myDonations.pageTitle')}</h1>
        <p>{t('myDonations.pageSubtitle')}</p>
      </div>

      <div className="my-donations-page">
        {/* Summary */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 32 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: '4px solid var(--saffron)' }}>
            <div style={{ fontSize: '0.85rem', color: '#888' }}>{t('myDonations.totalDonated')}</div>
            <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--saffron)' }}>₹{total.toLocaleString('en-IN')}</div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: '4px solid var(--green)' }}>
            <div style={{ fontSize: '0.85rem', color: '#888' }}>{t('myDonations.successfulDonations')}</div>
            <div style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--green)' }}>{donations.filter(d => d.paymentStatus === 'success').length}</div>
          </div>
          <div style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', borderLeft: '4px solid #DAA520' }}>
            <div style={{ fontSize: '0.85rem', color: '#888' }}>{t('myDonations.totalTransactions')}</div>
            <div style={{ fontSize: '1.8rem', fontWeight: 700, color: '#DAA520' }}>{donations.length}</div>
          </div>
        </div>

        {loading ? (
          <div className="loader"><div className="spinner" /></div>
        ) : donations.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#888' }}>
            <div style={{ fontSize: '4rem', marginBottom: 12 }}>🙏</div>
            <h3 style={{ marginBottom: 8 }}>{t('myDonations.noDonationsYet')}</h3>
            <p>{t('myDonations.noDonationsDesc')}</p>
            <a href="/donations" className="btn btn-primary" style={{ marginTop: 20, display: 'inline-flex' }}>{t('myDonations.donateNow')}</a>
          </div>
        ) : (
          <div>
            {donations.map(d => (
              <div key={d._id} className="donation-item">
                <div className="donation-item-info">
                  <h4>{purposeMap[d.purpose] || d.purpose}</h4>
                  <p>{t('myDonations.txnId', { id: d.txnId })}</p>
                  {d.receiptNumber && <p>{t('myDonations.receipt', { num: d.receiptNumber })}</p>}
                  <p>{new Date(d.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
                  {d.message && <p style={{ fontStyle: 'italic', color: '#999', fontSize: '0.82rem' }}>"{d.message}"</p>}
                </div>
                <div className="donation-item-right">
                  <div className="donation-item-amount">₹{d.amount?.toLocaleString('en-IN')}</div>
                  <span className={`donation-item-status status-${d.paymentStatus}`}>{statusMap[d.paymentStatus] || d.paymentStatus}</span>
                  {d.paymentStatus === 'success' && (
                    <div style={{ marginTop: 8 }}>
                      <Link to={`/donation/receipt/${d.txnId}`} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', background: 'none', border: '1px solid var(--saffron)', color: 'var(--saffron)', borderRadius: 6, padding: '4px 10px', fontSize: '0.8rem', textDecoration: 'none' }}>
                        {t('myDonations.receiptButton')}
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ background: 'var(--green-light)', borderRadius: 10, padding: 16, marginTop: 24, fontSize: '0.85rem', color: '#444', lineHeight: 1.6 }}>
          <strong>{t('myDonations.taxExemptionTitle')}</strong> {t('myDonations.taxExemptionText')}
        </div>
      </div>
    </div>
  );
}
